import { sortByDistance } from "sort-by-distance";

const URL = process.env.REACT_APP_API_SERVER;

export const register = async (data: any) => {
  try {
    const rawResponse = await fetch(`${URL}/api/register`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const registerMerchant = async (data: any) => {
  try {
    const rawResponse = await fetch(`${URL}/api/register/merchant`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const login = async (data: any) => {
  try {
    const rawResponse = await fetch(`${URL}/api/login`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const content = await rawResponse.json();
    const user = content.user;

    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("access_token", content?.access_token);
    localStorage.setItem("expires_in", content?.expires_in);
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const getMerchantsByRange = async (data?: any) => {
  try {
    const rawResponse = await fetch(`${URL}/api/merchants/range-journey-1`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const content = await rawResponse.json();
    if (data?.location?.lat) {
      const origin = {
        x: data?.location?.lat,
        y: data?.location?.long,
      };
      content.rows = sortByDistance(
        origin,
        content?.rows?.map((row: { location: any }) => ({
          ...row,
          x: row?.location?.coordinates?.[1],
          y: row?.location?.coordinates?.[0],
        }))
      );
      return content;
    }

    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const getMerchantsByRangeNonBookable = async (data: any) => {
  try {
    const rawResponse = await fetch(`${URL}/api/merchants/range-journey-2`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const content = await rawResponse.json();
    if (data?.location?.lat) {
      const origin = {
        x: data?.location?.lat,
        y: data?.location?.long,
      };

      let mergedArrays = content?.merchants.concat(content?.places);
      mergedArrays = sortByDistance(
        origin,
        mergedArrays?.map((row: { location: any }) => ({
          ...row,
          x: row?.location?.coordinates?.[1],
          y: row?.location?.coordinates?.[0],
        }))
      );

      return mergedArrays;
    }
    let mergedArraysNoSorting = content?.merchants.concat(content?.places);
    return mergedArraysNoSorting;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const updateUser = async (data: any, id: string | number) => {
  try {
    const test = localStorage.getItem("user");
    const use = test !== null ? JSON.parse(test) : null;

    const rawResponse = await fetch(`${URL}/api/users/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + use?.access_token,
      },
    });
    const content = await rawResponse.json();

    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const createCheckoutSession = async (data: any) => {
  try {
    const access_token = localStorage.getItem("access_token");

    const rawResponse = await fetch(
      `${URL}/api/payments/create-checkout-session`,
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Bearer " + access_token,
          "Content-Type": "application/json",
        },
      }
    );

    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const resetPasswordRequest = async (data: any) => {
  try {
    const access_token = localStorage.getItem("access_token");

    const rawResponse = await fetch(`${URL}/api/login/reset-password`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const changePassword = async (data: any) => {
  try {
    // const access_token = localStorage.getItem("access_token");

    const rawResponse = await fetch(`${URL}/api/login/change-password`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: "Bearer",
        "Content-Type": "application/json",
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const addItemToCart = async (data: any) => {
  try {
    const access_token = localStorage.getItem("access_token");
    const rawResponse = await fetch(`${URL}/api/cart/add`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const removeItemFromCart = async (id: number) => {
  try {
    const access_token = localStorage.getItem("access_token");
    const rawResponse = await fetch(`${URL}/api/cart/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};

export const postRequest = async (data: any, endpoint: string) => {
  try {
    const access_token = localStorage.getItem("access_token");
    console.log(access_token);

    const rawResponse = await fetch(`${URL}/api/${endpoint}`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
    const content = await rawResponse.json();
    return content;
  } catch (err) {
    return {
      error: true,
      errOb: err,
    };
  }
};
